import Vue from 'vue'
import App from './App.vue'
import i18n from './plugins/i18n'
import vuetify from './plugins/vuetify'
// import firebase from './plugins/firebase'
import router from './router'
import store from './store'
import {
  initializeAuthListener,
  getCurrentUser,
  getUserLocale,
  getUserRole,
  isUserAdmin,
} from './services/authService'

Vue.config.productionTip = false

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth)
  const requiresAdmin = to.matched.some((record) => record.meta.requiresAdmin)
  const requiredRoles = to.matched.map((record) => (record.meta && record.meta.roles) || []).flat()

  const isAuthenticated = getCurrentUser()
  i18n.locale = await getUserLocale()
  vuetify.framework.lang.current = i18n.locale
  if (requiresAuth && !isAuthenticated) {
    //session is expired
    const redirectUrl = window.location.pathname
    next('/login?redirect_url=' + redirectUrl)
  } else if (requiresAdmin && !(await isUserAdmin())) {
    //forbidden, redirect to home
    next('/')
  } else if (requiredRoles.length > 0) {
    // allow admins to access all role-protected routes
    if (await isUserAdmin()) {
      next()
    } else {
      const role = await getUserRole()
      if (requiredRoles.includes(role)) {
        next()
      } else {
        next('/')
      }
    }
  } else {
    next()
  }
})

let app
initializeAuthListener(async () => {
  if (!app) {
    i18n.locale = await getUserLocale()
    vuetify.framework.lang.current = i18n.locale
    app = new Vue({
      router,
      store,
      i18n,
      vuetify,
      render: (h) => h(App),
    }).$mount('#app')
  }
})
